"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportedTelemetryField = void 0;
var ReportedTelemetryField;
(function (ReportedTelemetryField) {
    ReportedTelemetryField["LEVEL"] = "level";
    ReportedTelemetryField["PERCENT"] = "percent";
    ReportedTelemetryField["TEMPERATURE"] = "temp";
    ReportedTelemetryField["V1_TEMPERATURE"] = "temperature";
    ReportedTelemetryField["OPERATING_MODE"] = "operatingMode";
    ReportedTelemetryField["SET_POINT_TEMPERATURE"] = "setTemperature";
    ReportedTelemetryField["FAN_SPEED"] = "fanSpeed";
    ReportedTelemetryField["VOLTAGE"] = "voltage";
    ReportedTelemetryField["PSI"] = "psi";
    ReportedTelemetryField["PRESSURE"] = "pressure";
    ReportedTelemetryField["ALARM"] = "alarm";
})(ReportedTelemetryField = exports.ReportedTelemetryField || (exports.ReportedTelemetryField = {}));
//# sourceMappingURL=ReportedTelemetryField.js.map